import React from "react";
import SFBaseThumbnail from "./base";
import SFTypography from "../typography";
import { SFStack } from "../grid";

import SFuseStyled from "../../hooks/useStyled";
import { Box, LinearProgress } from "@mui/material";
const { styled } = SFuseStyled();

const ContentContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "100%",
  "& .sf-stack": {
    position: "absolute",
    left: "50%",
    bottom: "50%",
    transform: "translate(-50%, 50%)",
    transition: "left 500ms, bottom 500ms, transform 500ms",
  },
  "& .icon-container": {
    position: "relative",
    left: "50%",
    transform: "translateX(-50%)",
    transformOrigin: "bottom left",
    transition: "left 500ms, transform 500ms",
  },
  "&:hover": {
    "& .sf-stack": {
      left: theme.spacing(1),
      bottom: theme.spacing(1),
      transform: "translate(0, 0)",
    },
    "& .icon-container": {
      left: "0",
      transform: "scale(0.7) translateX(0)",
    },
    "& video": {
      opacity: 1,
    },
  },
}));

const VideoContainer = styled(Box)(({ theme }) => ({
  position: "absolute",
  height: "100%",
  width: "100%",
  "& video": {
    position: "relative",
    width: "100%",
    height: "100%",
    opacity: 0,
    transition: "opacity 500ms",
    zIndex: -1,
    objectFit: "cover",
  },
}));

const ProgressContainerStyled = styled(Box)(({ theme }) => ({
  position: "absolute",
  bottom: 0,
  width: "100%",
}));

const LinearProgressStyled = styled(LinearProgress)(({ theme }) => ({
  height: 3,
  borderBottomLeftRadius: 5,
  borderBottomRightRadius: 5,
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
  backgroundColor: theme.palette.grey400.main,
}));

const SFVideoThumbnail = ({
  image = null,
  onClick = null,
  lazyLoad = false,
  icon = null,
  title = null,
  video = null,
  progress = 0,
  hasMinWidth = true,
  className = ""
}) => (
  <SFBaseThumbnail
    onClick={onClick}
    image={image}
    lazyLoad={lazyLoad}
    hasMinWidth={hasMinWidth}
    label={title}
    className={className}
  >
    <ContentContainer className="video-overlay-container">
      {video && (
        <VideoContainer>
          <video className="video" autoPlay loop muted>
            <source src={video} type="video/mp4" />
          </video>
        </VideoContainer>
      )}
      <SFStack className="sf-stack" spacing={1} alignItems="flex-start">
        {icon && <div className="icon-container">{icon}</div>}
        <SFTypography variant="academyCardTitle">{title}</SFTypography>
      </SFStack>
    </ContentContainer>
    {progress > 0 && (
      <ProgressContainerStyled>
        <LinearProgressStyled
          variant="determinate"
          value={progress}
          color={progress === 100 ? "green300" : "blue300"}
        />
      </ProgressContainerStyled>
    )}
  </SFBaseThumbnail>
);

export default SFVideoThumbnail;
